// extracted by mini-css-extract-plugin
export default {"StatusBox":"StatusBox_StatusBox__-HWtT","status":"StatusBox_status__qpm8E","select":"StatusBox_select__LcPvq","icon":"StatusBox_icon__RUfUd"};